module.exports = __webpack_public_path__ + "img/face-anxious-sweat.994bf582.svg";